export const Skills_data = {
    softskills: [
      "Quick learner",
      "Problem Solving",
      "Time management",
      "Team player",
      "Leadership",
      "Flexible",
    ],
    hardSkills: {
      programmingLanguages: ["Java", "Python", "JavaScript"],
      "Development Framework": ["React", "Spring Boot"],
      "Testing Framework": ["TestNG", "JUnit"],
      Automation: {
        Browser: ["Selenium (WebDriver & Grid)", "PlayWright"],
        Windows: ["Uft Developer"],
        API: ["Rest Assured", "Karate DSL"],
      },
      BDD: ["Gherkin"],
      "VCS/SCM": ["Git"],
      CICD: ["Jenkins"],
      "software project management": ["Apache Maven"],
      Containerization: ["Docker"],
    },
};
